

export const MEDIA_TYPE_IMAGE = 'MEDIA_TYPE_IMAGE';
// export const MEDIA_TYPE_VIDEO = 'MEDIA_TYPE_VIDEO';

export const MEDIA_DATA_TYPE_FILE = 'MEDIA_DATA_TYPE_FILE';
export const MEDIA_DATA_TYPE_OBJECT = 'MEDIA_DATA_TYPE_OBJECT';